import React from 'react';
import { steps, deliveryImage } from '../data/mock';

const HowItWorks = () => {
  return (
    <section id="how" className="relative py-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={deliveryImage}
                alt="MaLife delivery driver in action"
                className="w-full h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0b2f5c]/80 via-transparent to-transparent" />

              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 backdrop-blur-md rounded-2xl p-5 shadow-xl">
                  <div className="flex items-center justify-between mb-2">
                    <div className="text-xs font-semibold text-sky-600 uppercase tracking-widest">Live now</div>
                    <div className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                      <span className="text-[10px] font-semibold text-slate-600">On route</span>
                    </div>
                  </div>
                  <div className="text-sm font-bold text-[#0b2f5c]">Delivery to Extension 12</div>
                  <div className="text-xs text-slate-500 mt-1">Arriving in 8 min · Tebogo M.</div>
                  <div className="mt-3 h-1.5 rounded-full bg-slate-200 overflow-hidden">
                    <div className="h-full w-2/3 bg-gradient-to-r from-sky-400 to-sky-600 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-sky-300/40 rounded-full blur-3xl -z-10" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-sky-400/30 rounded-full blur-3xl -z-10" />
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold tracking-wide uppercase mb-4">
              How it works
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0b2f5c] tracking-tight leading-tight mb-6">
              Simple as one, two,<br /> three, four.
            </h2>
            <p className="text-slate-600 leading-relaxed mb-10">
              Getting started with MaLife takes less than a minute. Here is how it works.
            </p>

            <div className="space-y-5">
              {steps.map((s) => (
                <div
                  key={s.num}
                  className="group flex gap-5 p-4 rounded-2xl hover:bg-white hover:shadow-md transition-all"
                >
                  <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-sky-200 group-hover:scale-105 transition-transform">
                    {s.num}
                  </div>
                  <div>
                    <h4 className="font-bold text-[#0b2f5c] mb-1">{s.title}</h4>
                    <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
